/**
 * 「撮影」の中のタブ（Issue #732）: 撮影予定 / 収録の設定（#791）/ TetherCam（接続中の一覧とデバイスごとの設定。#789 / #790）/
 * 声の席の確かめ（同席の 2 台の突き合わせの実測。#858）。
 * 撮影の設定（/shoot/setup）は Issue #801 で消した（座標はデバイスの設定＋収録の設定だけ）。
 * ナビの「撮影」は /shoot で、中の画面がこの帯で行き来する。各画面が自分の先頭に置く。
 * 帯の下に、いま動いている補正サーバー・ゲームサーバー（本番へ名乗っているもの。Issue #882）を出す。
 */
import { NavLink } from 'react-router-dom';
import LiveServersStatus from './LiveServersStatus';

export const SHOOT_TABS = [
  { to: '/shoot/schedule', label: '撮影予定' },
  { to: '/shoot/recording', label: '収録の設定' },
  { to: '/shoot/devices', label: 'TetherCam' },
  { to: '/shoot/speech', label: '声の席の確かめ' },
];

export default function ShootNav() {
  return (
    <>
      <nav className="subnav" aria-label="撮影" data-testid="shoot-nav">
        {SHOOT_TABS.map((t) => <NavLink key={t.to} to={t.to}>{t.label}</NavLink>)}
      </nav>
      <LiveServersStatus />
    </>
  );
}
